// @ts-nocheck
import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  TextCell,
  IdentityCell,
  DateCell,
  ActionsCell,
  MoneyCell,
  CustomHeader
} from '@/components/table/columns'
import {SaleStatusCell, SaleProductCell} from './SaleCells'

const df = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
} as Intl.DateTimeFormatOptions

const Columns: ReadonlyArray<Column<Model>> = [{
  Header: (props) => <CustomHeader tableProps={props} title='Name' className='min-w-125px' />,
  id: 'username',
  Cell: ({...props}) =>
    <IdentityCell
      email={props.data[props.row.index].user.email}
      displayName={props.data[props.row.index].user.username}
      to={`/p2c/customers/${props.data[props.row.index].user._id}/overview`}
    />
}, {
  Header: (props) => <CustomHeader tableProps={props} title="Status" className='min-w-125px' />,
  id: 'status',
  Cell: ({...props}) => <SaleStatusCell status={props.data[props.row.index].statuses.at(-1).status}/>
}, {
  Header: (props) => <CustomHeader tableProps={props} title="Date" className='min-w-125px' />,
  id: 'date',
  Cell: ({...props}) => <DateCell date={props.data[props.row.index].date} format={df}/>
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Product' className='min-w-125px text-start pe-0 sortable' />,
  id: 'product',
  className: 'text-start pe-0',
  Cell: ({...props}) => (
    <SaleProductCell
      product={props.data[props.row.index].product}
      gift={props.data[props.row.index].gift}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='DEBIT' className='min-w-125px text-end pe-0 sortable' />,
  id: 'debit',
  className: 'text-end pe-0',
  Cell: ({...props}) => <TextCell content={props.data[props.row.index].debit} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Amount' className='min-w-125px text-end pe-0 sortable' />,
  id: 'amount',
  className: 'text-end pe-0',
  Cell: (props) => (
    props.data[props.row.index].amount ? (
      <MoneyCell amount={props.data[props.row.index].amount} currency='EUR' />
    ) : (
      <></>
    )
  )
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => (
    <ActionsCell
      itemForUpdate={props.data[props.row.index]}
      actions={[{
        icon: 'exit-right-corner',
        label: 'Details',
        openModal: 'details'
      }]}
    />
  )
}]

export {Columns}
